(() => {
  function init(scope) {
    scope.querySelectorAll('[data-cv-sale-deadline]').forEach(banner => {
      if (banner.dataset.ready) return;
      banner.dataset.ready = 'true';
      const deadline = Date.parse(banner.dataset.end);
      const root = banner.closest('[data-conversion]');
      let product;
      try { product = JSON.parse(root.querySelector('[data-cv-product]').textContent); } catch { return; }
      const tick = () => {
        const seconds = Math.floor((deadline - Date.now()) / 1000);
        if (!Number.isFinite(seconds) || seconds <= 0) { banner.hidden = true; return false; }
        const variant = product.variants.find(v => String(v.id) === root.querySelector('[data-cv-id]')?.value);
        banner.hidden = !variant?.available || !(variant.compare > variant.price);
        if (!banner.hidden) banner.querySelector('[data-cv-sale-saving]').textContent = `Save ${Math.round((variant.compare - variant.price) * 100 / variant.compare)}%`;
        banner.querySelector('[data-cv-countdown]').textContent = `${Math.floor(seconds / 86400)}d ${String(Math.floor(seconds / 3600) % 24).padStart(2, '0')}h ${String(Math.floor(seconds / 60) % 60).padStart(2, '0')}m ${String(seconds % 60).padStart(2, '0')}s`;
        return true;
      };
      if (tick()) {
        const timer = setInterval(() => { if (!banner.isConnected || !tick()) clearInterval(timer); }, 1000);
      }
    });
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('cv-motion-ready'); observer.unobserve(entry.target); }
    }), {threshold: .12});
    scope.querySelectorAll('.cv-story-grid article,.cv-section-heading,.cv-campaign').forEach(el => observer.observe(el));
    document.addEventListener('shopify:section:unload', () => observer.disconnect(), {once:true});
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
